/** Force refresh / redraw */

import { useCallback, useState } from 'react'

export const useRedraw = () => {
  const [, setRedraw] = useState({})
  return useCallback(() => setRedraw({}), [])
}
